<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'qna',
  data() {
    return {};
  },
};
</script>
